function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}
if (typeof window.BaseCarousel === 'undefined') {
  class BaseCarousel {
    constructor(container) {
      this.container = container;
      this.slider = container.querySelector('.rv8x4_slider');
      this.prevButton = container.querySelector('.rv8x4_button-prev');
      this.nextButton = container.querySelector('.rv8x4_button-next');
      this.randomSort = this.container.dataset.randomSort === 'true';
      
      if (!this.container || !this.slider) {
        console.error('Required elements not found');
        return;
      }

      this.productsToShow = parseInt(this.slider.dataset.productsToShow, 10);
      this.currentIndex = 0;
      
      // Set CSS variable for products to show
      this.slider.style.setProperty('--products-to-show', this.productsToShow);
    }

    setupEventListeners() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.slide('prev'));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.slide('next'));
      }

      // Touch events
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let isSwiping = false;
      
      const handleTouchStart = (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isSwiping = false;
      };
      
      const handleTouchMove = (e) => {
        if (isSwiping) {
          e.preventDefault();
          return;
        }
        
        const touchCurrentX = e.touches[0].clientX;
        const touchCurrentY = e.touches[0].clientY;
        const deltaX = Math.abs(touchCurrentX - touchStartX);
        const deltaY = Math.abs(touchCurrentY - touchStartY);
        
        if (deltaX > deltaY && deltaX > 10) {
          isSwiping = true;
          e.preventDefault();
        }
      };
      
      const handleTouchEnd = (e) => {
        touchEndX = e.changedTouches[0].clientX;
        if (isSwiping) {
          if (touchStartX - touchEndX > 50) {
            this.slide('next');
          } else if (touchEndX - touchStartX > 50) {
            this.slide('prev');
          }
        }
      };
      
      this.slider.addEventListener('touchstart', handleTouchStart, { passive: true });
      this.slider.addEventListener('touchmove', handleTouchMove, { passive: false });
      this.slider.addEventListener('touchend', handleTouchEnd);

      this.touchListeners = {
        start: handleTouchStart,
        move: handleTouchMove,
        end: handleTouchEnd
      };

      // Resize handler
      this.boundUpdateVisibility = () => this.updateSliderVisibility();
      window.addEventListener('resize', this.boundUpdateVisibility);
    }

    slide(direction) {
      if (!this.slider.children.length) return;

      const itemWidth = this.slider.children[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.slider).gap);
      const isMobile = window.innerWidth <= 749;
      const visibleItems = isMobile ? 1 : this.productsToShow; // Consider only one item at a time on mobile
      const totalProducts = this.slider.children.length;
      
      // Calculate real maxIndex based on visible width
      const sliderWidth = this.slider.offsetWidth;
      const totalWidth = totalProducts * (itemWidth + gap) - gap;
      const maxScroll = totalWidth - sliderWidth;
      const maxIndex = Math.ceil(maxScroll / (itemWidth + gap));

      if (direction === 'prev' && this.currentIndex > 0) {
        this.currentIndex--;
      } else if (direction === 'next' && this.currentIndex < maxIndex) {
        this.currentIndex++;
      }

      const offset = this.currentIndex * -(itemWidth + gap);
      this.slider.style.transform = `translateX(${offset}px)`;
      this.updateSliderVisibility();
    }

    updateSliderVisibility() {
      if (!this.slider.children.length) return;

      const itemWidth = this.slider.children[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.slider).gap);
      const isMobile = window.innerWidth <= 749;
      const visibleItems = isMobile ? 1 : this.productsToShow;
      const totalProducts = this.slider.children.length;
      
      // Calculate real maxIndex based on visible width
      const sliderWidth = this.slider.offsetWidth;
      const totalWidth = totalProducts * (itemWidth + gap) - gap;
      const maxScroll = totalWidth - sliderWidth;
      const maxIndex = Math.ceil(maxScroll / (itemWidth + gap));

      if (this.prevButton) {
        this.prevButton.style.opacity = this.currentIndex <= 0 ? '0.5' : '1';
        this.prevButton.style.pointerEvents = this.currentIndex <= 0 ? 'none' : 'auto';
      }
      
      if (this.nextButton) {
        this.nextButton.style.opacity = this.currentIndex >= maxIndex ? '0.5' : '1';
        this.nextButton.style.pointerEvents = this.currentIndex >= maxIndex ? 'none' : 'auto';
      }
    } 

renderProducts(products) {
  
  
  this.slider.innerHTML = products.map(product => {
    const image = product.featuredImage;
    const price = product.priceRange?.minVariantPrice;
    const compareAtPrice = product.compareAtPriceRange?.maxVariantPrice;
    
   

    // Improved sale check
    const isOnSale = compareAtPrice?.amount && price?.amount && 
                    parseFloat(compareAtPrice.amount) > parseFloat(price.amount);
                    
    const isSoldOut = !product.availableForSale;
    const isComingSoon = product.tags?.includes('comingsoon');
    const hasPillowWalk = product.tags?.includes('Pillow Walk');
    const colorSwatch = product.options?.find(option => option.name.toLowerCase() === 'color');
    const silhouette = product.metafields?.custom?.silhouette;
    
    // Format price function with additional safety checks
    const formatPrice = (priceObj) => {
      if (!priceObj || typeof priceObj.amount !== 'number' && typeof priceObj.amount !== 'string') {
        console.warn('Invalid price object:', priceObj);
        return '';
      }
      
      try {
        const amount = typeof priceObj.amount === 'string' ? 
          parseFloat(priceObj.amount) : priceObj.amount;
          
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: priceObj.currencyCode || 'USD'
        }).format(amount);
      } catch (error) {
        console.error('Price formatting error:', error);
        return '';
      }
    };
    
    // Price HTML generation with debug logging
    // This should replace the getPriceHTML function in the renderProducts method
const getPriceHTML = () => {
  if (!price?.amount) {
    console.warn('No valid price found for:', product.title);
    return '';
  }
  
 

  // Ensure we're working with numeric values for comparison
  const priceValue = parseFloat(price.amount);
  const compareAtPriceValue = parseFloat(compareAtPrice?.amount || '0');
  const isOnSale = compareAtPrice?.amount && compareAtPriceValue > priceValue;

  // Format price with the correct currency
  const formatPrice = (amount, currencyCode) => {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode || 'GBP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(parseFloat(amount));
  };

  if (isOnSale) {
    return `
      <div class="price price--on-sale">
        <div class="price__sale">
          <s class="price-item price-item--regular">
            ${formatPrice(compareAtPrice.amount, compareAtPrice.currencyCode)}
          </s>
          <span class="price-item price-item--sale">
            ${formatPrice(price.amount, price.currencyCode)}
          </span>
        </div>
      </div>
    `;
  }

  return `
    <div class="price">
      <div class="price__regular">
        <span class="price-item price-item--regular">
          ${formatPrice(price.amount, price.currencyCode)}
        </span>
      </div>
    </div>
  `;
};
    
    return `
      <div class="rv8x4_product">
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media">
            <div class="card__inner ratio" style="--ratio-percent: 100%">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  ${image ? `
                    <img
                      srcset="${image.url} ${image.width}w"
                      src="${image.url}"
                      sizes="(min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                      alt="${image.altText || product.title}"
                      class="motion-reduce"
                      loading="lazy"
                      width="${image.width}"
                      height="${image.height}"
                    >
                  ` : ''}
                </div>
               
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading">
                  <a href="/products/${product.handle}" class="full-unstyled-link">
                    ${product.title}${silhouette ? ` - ${silhouette}` : ''}
                  </a>
                </h3>
                ${colorSwatch ? `
                  <div class="pdp__color-selector">
                    <div class="pdp__label">
                      Colour / <span class="pdp__current-color" style="text-transform: capitalize">${colorSwatch.values[0]}</span>
                    </div>
                  </div>
                ` : ''}
                <div class="card-information">
                  <div class="price">
                    <div class="price__container">
                      ${getPriceHTML()}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card__badge">
                ${isSoldOut ? `
                  ${isComingSoon ? `
                    <span class="badge badge--bottom-left" style="background: orange !important;">
                      Coming Soon
                    </span>
                  ` : `
                    <span class="badge badge--bottom-left">
                      Sold Out
                    </span>
                  `}
                ` : isOnSale ? `
                  ${product.tags?.includes("SS24-SALE-20pc") ? `
                    <span class="badge badge--top-left">
                      Extra 20% Off
                    </span>
                  ` : `
                    <span class="badge badge--top-left">
                      Sale
                    </span>
                  `}
                ` : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }).join('');

  
}

    destroy() {
      if (this.touchListeners) {
        this.slider.removeEventListener('touchstart', this.touchListeners.start);
        this.slider.removeEventListener('touchend', this.touchListeners.end);
      }
      window.removeEventListener('resize', this.boundUpdateVisibility);
    }
  }

  // Product Recommendations class
  class ProductRecommendations extends BaseCarousel {
    constructor(container) {
      super(container);
      this.sourceType = this.container.dataset.sourceType;
      this.collectionId = this.container.dataset.collectionId;
      this.customProducts = JSON.parse(this.container.dataset.customProducts || '[]');
      this.showForCollections = JSON.parse(this.container.dataset.showForCollections || '[]');
      this.showForProducts = JSON.parse(this.container.dataset.showForProducts || '[]');
      this.maxProducts = this.sourceType === 'collection' ? 30 : this.customProducts.length;
      this.init();
    }

   async init() {
  try {
    const shouldShow = await this.shouldDisplay();
    if (!shouldShow) {
     
      this.container.style.display = 'none';
      return;
    }
    
    await this.fetchAndRenderProducts();
    this.setupEventListeners();
  } catch (error) {
    console.error('Initialization error:', error);
    this.container.style.display = 'none';
  }
    }
    
getCurrentProductId() {
  // Try different ways to get the product ID
  const fromShopify = Shopify?.product?.id?.toString();
  const fromMeta = window?.meta?.product?.id?.toString();
  const fromURL = window.location.pathname.match(/\/products\/[^\/]+\/([0-9]+)/)?.[1];
  
 

  return fromShopify || fromMeta || fromURL;
}
   async shouldDisplay() {
  const currentProductId = this.getCurrentProductId();
  if (!currentProductId) {
   
    return false;
  }

  // Check if we're using collection source type and have a collection selected
  if (this.sourceType === 'collection' && this.collectionId) {
    try {
      const productCollections = await this.fetchProductCollections(currentProductId);
      // Ensure we're comparing the numeric part of the collection IDs
      const sourceCollectionId = this.collectionId.toString().replace('gid://shopify/Collection/', '');
      const isInSourceCollection = productCollections.some(id => 
        id.toString().replace('gid://shopify/Collection/', '') === sourceCollectionId
      );
      
    

      // Only continue if the product is in the source collection
      if (!isInSourceCollection) {
       
        return false;
      }
    } catch (error) {
      console.error('Error checking source collection:', error);
      return false;
    }
  }

  // If specific products are set, check if current product is in the list
  if (this.showForProducts.length > 0) {
    const shouldShow = this.showForProducts.includes(currentProductId);
   
    return shouldShow;
  }

  // If specific collections are set, check if current product belongs to any of them
  if (this.showForCollections.length > 0) {
    try {
      const productCollections = await this.fetchProductCollections(currentProductId);
      const shouldShow = this.showForCollections.some(allowedId => 
        productCollections.some(productCollectionId => 
          productCollectionId.toString().replace('gid://shopify/Collection/', '') === allowedId.toString().replace('gid://shopify/Collection/', '')
        )
      );
      
     
      return shouldShow;
    } catch (error) {
      console.error('Error fetching product collections:', error);
      return false;
    }
  }

  // If no display conditions are set, show for all products
  if (this.showForCollections.length === 0 && this.showForProducts.length === 0) {
   
    return true;
  }

 
  return false;
}

    async fetchProductCollections(productId) {
      const shopDomain = Shopify?.shop;
      if (!shopDomain) {
        throw new Error('Shop domain not found');
      }

      const response = await fetch(`https://${shopDomain}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '1c2228dd57be02d3e824212980db1a56'
        },
        body: JSON.stringify({
          query: `
            query getProductCollections($productId: ID!) {
              product(id: $productId) {
                collections(first: 50) {
                  nodes {
                    id
                  }
                }
              }
            }
          `,
          variables: {
            productId: `gid://shopify/Product/${productId}`
          }
        })
      });

      const { data } = await response.json();
      return (data?.product?.collections?.nodes || [])
        .map(node => node.id.split('/').pop());
    }

async fetchAndRenderProducts() {
  try {
    let products = [];
    
    // For collection source type
    if (this.sourceType === 'collection') {
      if (!this.collectionId) {
        const allProducts = await this.fetchAllProducts();
        products = allProducts.slice(0, this.maxProducts);
      } else {
        products = await this.fetchProductData();
      }
    }
    // For custom products source type
    else if (this.sourceType === 'custom') {
      if (this.customProducts.length > 0) {
        products = await this.fetchProductData();
      } else {
        const allProducts = await this.fetchAllProducts();
        products = allProducts.slice(0, this.maxProducts);
      }
    }

    // Filter out current product
    const currentProductId = this.getCurrentProductId();
  

    if (currentProductId) {
      products = products.filter(product => {
        const productId = product.id.split('/').pop();
       
        return productId !== currentProductId;
      });
    }

    // Randomize products if random_sort is enabled
    if (this.randomSort) {
    
      products = shuffleArray([...products]); // Use the existing shuffleArray function
    }

  

    if (products && products.length > 0) {
      this.renderProducts(products);
      this.container.classList.add('is-visible');
      this.updateSliderVisibility();
    } else {
      this.container.style.display = 'none';
    }
  } catch (error) {
    console.error('Error fetching products:', error);
    this.container.style.display = 'none';
  }
}
    

    async fetchAllProducts() {
      const shopDomain = Shopify?.shop;
      if (!shopDomain) {
        throw new Error('Shop domain not found');
      }

      const response = await fetch(`https://${shopDomain}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '1c2228dd57be02d3e824212980db1a56'
        },
        body: JSON.stringify({
          query: `
            query getAllProducts($first: Int!) {
              products(first: $first) {
                nodes {
                  id
                     availableForSale
              tags
                  title
                  handle
                  featuredImage {
                    url(transform: {
                      maxWidth: 700
                      maxHeight: 700
                      crop: CENTER
                      scale: 2
                      preferredContentType: WEBP
                    })
                    altText
                    width
                    height
                  }
                  priceRange {
                    minVariantPrice {
                      amount
                      currencyCode
                    }
                  }
                    compareAtPriceRange {
    maxVariantPrice {
      amount
      currencyCode
    }
  }
                }
              }
            }
          `,
          variables: {
            first: this.maxProducts
          }
        })
      });

      const { data } = await response.json();
      return data?.products?.nodes || [];
    }

    async fetchProductData() {
      const shopDomain = Shopify?.shop;
      if (!shopDomain) {
        throw new Error('Shop domain not found');
      }

      const query = this.sourceType === 'collection' ? `
        query getCollectionProducts($collectionId: ID!, $first: Int!) {
          collection(id: $collectionId) {
            products(first: $first) {
              nodes {
                id
                   availableForSale
              tags
                title
                handle
                featuredImage {
                  url(transform: {
                    maxWidth: 700
                    maxHeight: 700
                    crop: CENTER
                    scale: 2
                    preferredContentType: WEBP
                  })
                  altText
                  width
                  height
                }
                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
                  compareAtPriceRange {
    maxVariantPrice {
      amount
      currencyCode
    }
  }
              }
            }
          }
        }
      ` : `
        query getProducts($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on Product {
              id
              title
              handle
              featuredImage {
                url(transform: {
                  maxWidth: 700
                  maxHeight: 700
                  crop: CENTER
                  scale: 2
                  preferredContentType: WEBP
                })
                altText
                width
                height
              }
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
                compareAtPriceRange {
    maxVariantPrice {
      amount
      currencyCode
    }
  }
            }
          }
        }
      `;

      const variables = this.sourceType === 'collection' ? {
        collectionId: `gid://shopify/Collection/${this.collectionId}`,
        first: this.maxProducts
      } : {
        ids: this.customProducts.map(id => `gid://shopify/Product/${id}`)
      };

      const response = await fetch(`https://${shopDomain}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '1c2228dd57be02d3e824212980db1a56'
        },
        body: JSON.stringify({ query, variables })
      });

      const { data } = await response.json();
      return this.sourceType === 'collection' 
        ? data?.collection?.products?.nodes || []
        : data?.nodes || [];
    }
  }

  // Recently Viewed Products class
  class RecentlyViewedProducts extends BaseCarousel {
    constructor(container) {
      super(container);
      this.productKey = 'recently_viewed_products';
      this.productLimit = 12;
      this.init();
    }

    async init() {
      try {
        if (this.isProductPage()) {
          this.addCurrentProduct();
        }
        
        await this.fetchAndRenderProducts();
        this.setupEventListeners();
      } catch (error) {
        console.error('Initialization error:', error);
      }
    }

    isProductPage() {
      return window.location.pathname.includes('/products/');
    }
getCurrentProductId() {
  // Try different ways to get the product ID
  const fromShopify = Shopify?.product?.id?.toString();
  const fromMeta = window?.meta?.product?.id?.toString();
  const fromURL = window.location.pathname.match(/\/products\/[^\/]+\/([0-9]+)/)?.[1];
  
 

  return fromShopify || fromMeta || fromURL;
}

  async fetchAndRenderProducts() {
  let recentProducts = [];
  try {
    recentProducts = JSON.parse(localStorage.getItem(this.productKey)) || [];
  } catch (e) {
    console.error('Error reading from localStorage:', e);
  }

  // Filter out current product from recently viewed list
  const currentProductId = this.getCurrentProductId();
 
  
  if (currentProductId) {
    recentProducts = recentProducts.filter(id => {
      const storedId = id.includes('gid://shopify/Product/') ? id.split('/').pop() : id;
   
      return storedId !== currentProductId;
    });
  }

  if (recentProducts.length === 0) {
    this.container.style.display = 'none';
    return;
  }

  try {
    const products = await this.fetchProductData(recentProducts);

    
    if (products && products.length > 0) {
      this.renderProducts(products);
      this.container.classList.add('is-visible');
      this.updateSliderVisibility();
    } else {
      this.container.style.display = 'none';
    }
  } catch (error) {
    console.error('Error fetching products:', error);
    this.container.style.display = 'none';
  }
}

addCurrentProduct() {
  const currentProductId = this.getCurrentProductId();

  
  if (!currentProductId) {
    
    return;
  }

  let recentProducts = [];
  try {
    recentProducts = JSON.parse(localStorage.getItem(this.productKey)) || [];
  
    
    // Move the current product to the start if it exists, otherwise add it
    recentProducts = recentProducts.filter(id => {
      const storedId = id.includes('gid://shopify/Product/') ? id.split('/').pop() : id;
      return storedId !== currentProductId;
    });
    recentProducts.unshift(currentProductId);
    
    // Limit the number of stored products
    recentProducts = recentProducts.slice(0, this.productLimit);
    
    localStorage.setItem(this.productKey, JSON.stringify(recentProducts));
  
  } catch (e) {
    console.error('Error handling recently viewed products:', e);
  }
}

    async fetchProductData(productIds) {
      const shopDomain = Shopify?.shop;
      if (!shopDomain) {
        throw new Error('Shop domain not found');
      }

      const response = await fetch(`https://${shopDomain}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '1c2228dd57be02d3e824212980db1a56'
        },
        body: JSON.stringify({
          query: `
            query getProducts($ids: [ID!]!) {
              nodes(ids: $ids) {
                ... on Product {
                  id
                  title
                  handle
                     availableForSale
              tags
                  featuredImage {
                    url(transform: {
                      maxWidth: 700
                      maxHeight: 700
                      crop: CENTER
                      scale: 2
                      preferredContentType: WEBP
                    })
                    altText
                    width
                    height
}
                  priceRange {
                    minVariantPrice {
                      amount
                      currencyCode
                    }
                  }
                    compareAtPriceRange {
    maxVariantPrice {
      amount
      currencyCode
    }
  }
                }
              }
            }
          `,
          variables: {
            ids: productIds.map(id => `gid://shopify/Product/${id}`)
          }
        })
      });

      const { data } = await response.json();
      return data?.nodes || [];
    }
  }
class ShopifyAIRecommendations extends BaseCarousel {
  constructor(container) {
    super(container);
    this.productId = window?.meta?.product?.id;
    this.init();
  }

  async init() {
    try {
      if (!this.productId) {
       
        return;
      }

      // First fetch recommendations data to see if we have any
      const recommendationsUrl = `/recommendations/products.json?product_id=${this.productId}&limit=30&intent=related`;
      const response = await fetch(recommendationsUrl);
      const data = await response.json();

    

      if (!data.products || data.products.length === 0) {
      
        this.container.style.display = 'none';
        return;
      }

      // Now fetch the HTML section with the recommendations
      const sectionUrl = `/recommendations/products?product_id=${this.productId}&limit=30&section_id=${this.container.dataset.sectionId}`;
      const sectionResponse = await fetch(sectionUrl);
      const html = await sectionResponse.text();

      // Parse and insert the section HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Look for our specific product elements
      const productElements = doc.querySelectorAll('.rv8x4_product');

      if (productElements.length > 0) {
        this.slider.innerHTML = '';
        productElements.forEach((element, index) => {
        
          this.slider.appendChild(element.cloneNode(true));
        });
        
        this.container.classList.add('is-visible');
        this.setupEventListeners();
        this.updateSliderVisibility();
      } else {
       
        this.container.style.display = 'none';
      }

    } catch (error) {
      console.error('Error fetching recommendations:', error);
      this.container.style.display = 'none';
    }
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('DOMContentLoaded', () => {
    // Helper to check if we're on a product page
    const isProductPage = () => window.location.pathname.includes('/products/');

    // Initialize Manual Product Recommendations (non-AI)
    document.querySelectorAll('.product-recommendations.rv8x4_container').forEach(container => {
      new ProductRecommendations(container);
    });

    // Initialize AI Recommendations (only on product pages)
    if (isProductPage()) {
      document.querySelectorAll('.ai-recommendations.rv8x4_container').forEach(container => {
        new ShopifyAIRecommendations(container);
      });
    }

    // Initialize Recently Viewed Products
    document.querySelectorAll('.recently-viewed-products.rv8x4_container').forEach(container => {
      new RecentlyViewedProducts(container);
    });
  });

  // Export classes to window object
  window.BaseCarousel = BaseCarousel;
  window.ProductRecommendations = ProductRecommendations;
  window.RecentlyViewedProducts = RecentlyViewedProducts;
  window.ShopifyAIRecommendations = ShopifyAIRecommendations;
}}